// 返回码
var errorCode = {
    success: 1,
}

var user = {
    submitMsg: {
        url: "/questionnaires",
        method: "POST",
        version: "1.0.0"
    }
}
var banner = {
    list: {
        url: "/banners",
        method: "GET",
        version: "1.1.0"
    }
}
var highlight = {
    list: {
        url: "/highlights",
        method: "GET",
        version: "1.1.0"
    }
}
var cases = {
    list: {
        url: "/cases",
        method: "GET",
        version: "1.1.0"
    }
}
var article = {
    list: {
        url: "/articles",
        method: "GET",
        version: "1.1.0"
    },
    detail: {
        url: "/articles/:id",
        method: "GET",
        version: "1.1.0"
    }
}
var price = {
    list: {
        url: "/packages",
        method: "GET",
        version: "1.5.5"
    }
}
var privacy_clause = {
    detail: {
        url: "/privacyClauses/:id",
        method: "GET",
        version: "1.5.7"
    }
}

export default {
    errorCode,
    user,
    banner,
    highlight,
    cases,
    article,
    price,
    privacy_clause
};



// WEBPACK FOOTER //
// ./src/configs/api-config.js